export const Scrim = () => {
  return <div className="absolute inset-0 bg-black bg-opacity-70 "></div>;
};
